import { KeyboardEvent } from "react";

export const misc = {
  preventArrowLeftRightConflictWithSheetNavigation: (event: KeyboardEvent) => {
    if (event.key === "ArrowLeft" || event.key === "ArrowRight") {
      event.stopPropagation();
    }
  },

  /**
   * Converts a string to title case by capitalizing the first letter of each word (if applicable).
   */
  toTitleCase: (str: string): string => {
    return str
      .toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  },
};
